// extracted by mini-css-extract-plugin
export default {"root":"Table_root__GtMEO","header":"Table_header__mYa0b","rotate":"Table_rotate__ftpu7","canSort":"Table_canSort__zQ2Xi","data":"Table_data__VJMVM","row":"Table_row__XG2L2"};